import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { Modal } from '../../components/common';

/**
 * OnlinePaymentWarningModal
 * ─────────────────────────
 * Specialized warning modal for online transaction deletion
 */
export default function OnlinePaymentWarningModal({ item, onClose, onConfirm }) {
  if (!item) return null;

  return (
    <Modal 
      title="Online Payment Warning" 
      onClose={onClose}
      size="sm"
      actions={
        <div style={{ display: 'flex', gap: 10, width: '100%' }}>
          <button className="btn btn-ghost" style={{ flex: 1 }} onClick={onClose}>
            Go Back
          </button>
          <button 
            className="btn btn-danger" 
            style={{ flex: 1 }} 
            onClick={() => {
              onConfirm(item);
              onClose();
            }}
          >
            Proceed to Delete
          </button>
        </div>
      }
    >
      <div style={{ textAlign: 'center', padding: '10px 0' }}>
        <div style={{ 
          width: 64, height: 64, borderRadius: '50%', background: 'rgba(239, 68, 68, 0.1)', 
          color: '#ef4444', display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 20px'
        }}>
          <FiAlertTriangle size={32} />
        </div>
        <h4 style={{ marginBottom: 12, color: 'var(--color-text)' }}>Caution: Online Transaction</h4>
        <p style={{ fontSize: '0.9rem', color: 'var(--color-text-muted)', lineHeight: 1.6, margin: 0 }}>
          This receipt (<strong>{item.receiptNo}</strong>) was paid online via Razorpay. 
          Deleting this record will <strong>NOT</strong> automatically refund the payment in the bank. 
          You must handle any refunds manually via the Razorpay dashboard.
        </p>
        <p style={{ fontSize: '0.9rem', color: 'var(--color-text-muted)', marginTop: 12 }}>
          Do you still want to proceed with deleting this record?
        </p>
      </div>
    </Modal>
  );
}
